import { render } from "./MessageReactions.vue?vue&type=template&id=4192804e"
import script from "./MessageReactions.vue?vue&type=script&lang=js"
export * from "./MessageReactions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\swing_vue_chat\\chat_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__